import { render, staticRenderFns } from "./GlLevel2CheckersQueueTable.vue?vue&type=template&id=66793d36&scoped=true&"
import script from "./GlLevel2CheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./GlLevel2CheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./GlLevel2CheckersQueueTable.vue?vue&type=style&index=0&id=66793d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66793d36",
  null
  
)

export default component.exports